/**
 * Created by Ning Jiang on 2021-06-29.
 */
import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {KarenLayers, Layers} from "../view/KarenLayers";
import {Karen} from "../Karen";
import {KarenParsedGameData} from "../server/data/KarenParsedGameData";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Bounce, TimelineLite, TimelineMax} from "gsap";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {KarenGameAssets} from "../KarenGameAssets";
import {Helper} from "@nolimitcity/slot-game/bin/utils/Helper";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {GameHelper} from "../../core/utils/GameHelper";
import {KarenGameMode} from "../server/KarenGameMode";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KarenGameConfig} from "../KarenGameConfig";
import {SpinePlayer} from "../../core/displayObject/SpinePlayer";

export class WinCapScreen extends ContinueScreen {

    protected bounceTl: TimelineMax;
    private _youWin: BitmapCountUp;
    private _background: SpinePlayer;
    private _dimmer: PIXI.Graphics;
    private _textSize: number = 110;
    private _countupEffect: PIXI.spine.Spine;

    constructor() {
        super(KarenLayers.getLayer(Layers.SCREENS)!);
        this.createDimmerGraphics();
        this._container.addChild(this._dimmer);
        this._background = new SpinePlayer("WinCapScreen", false);
        this._background.scale.set(0.8, 0.8);
        this._background.position.set(348, 405);
        this._countupEffect = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset("countUpEffect"));
        this._countupEffect.position.set(360, 495);
        this._continueButton.position.y = this._continueButton.y + 50;
        this._container.addChild(this._background);
        this._container.addChild(this._countupEffect);
        const style = {
            fontName: KarenGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: this._textSize,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._youWin = new BitmapCountUp(style);
        this._youWin.position.set(360, 495);
        this._container.addChild(this._youWin);
        let layer: StageLayer | undefined = KarenLayers.getLayer(Layers.SCREENS);
        if (layer != undefined) {
            layer.onResize = () => {
                this.onResize();
            }
        }
        this.onResize();
    }

    public showAnimation(onContinueCallBack: () => void): TimelineLite {
        Karen.keypadPlugin.setZeroBetSpinCounter(-1);
        if (Karen.model.gameData.mode === KarenGameMode.NORMAL) {
            KarenSoundManager.stopSoundEffect(KarenSoundConfig.MAIN_GAME_MUSIC);
        } else {
            KarenSoundManager.stopSoundEffect(KarenSoundConfig.FREESPIN_GAME_MUSIC);
            KarenSoundManager.fadeFSLoopSound(0);
            KarenSoundManager.stopSoundEffect(KarenSoundConfig.FREESPIN_WIN_LOOP);
        }
        this._dimmer.alpha = 0.9;
        let tl: TimelineLite = new TimelineLite({
            onStart: () => {
                if (Karen.model.parsedGameData.currentWinRatioConfig && !(Karen.model.parsedGameData.currentWinRatioConfig.ratio >= KarenGameConfig.WIN_RATIOS[4].ratio)) {
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.CAP_WIN_COUNTUP);
                }
            }
        });
        let wCStartDuration: number = this._background.fetchDuration("WinCap_Start");
        tl.add(this._background.play({name: "WinCap_Start", loop: false, showOnEnd: true})).add(() => {
            this._background.play({name: "WinCap_Loop", loop: true})
        });
        const data: KarenParsedGameData = Karen.model.parsedGameData;
        if ((data.totalWin).toString().length >= 8) {
            this._youWin.fontSize = this._textSize - 10;
        } else {
            this._youWin.fontSize = this._textSize;
        }
        tl.add(this._youWin.getCountUpAnimation(0, data.totalWin, 9.9, 'power3.inOut'), 0);

        tl.add([
                this.bounceHit(5, 0.25),
                this.setCountupEffect()]
            , 9.9);
        tl.add(() => {
            KarenSoundManager.playLoopSound(KarenSoundConfig.CAP_WIN_LOOP);
            Karen.keypadPlugin.setWin(0);
            this.enableContinueButton();
        }, 11.0);
        this.show(onContinueCallBack);
        tl.play();
        return tl;
    }

    private createDimmerGraphics():void{
        const dimension:number=Math.max(NolimitApplication.screenBounds.width,NolimitApplication.screenBounds.height)+500;
        this._dimmer = new PIXI.Graphics();
        this._dimmer.beginFill(0x000000, 1);
        this._dimmer.drawRect(0, 0 , dimension, dimension);
        this._dimmer.endFill();
        this._dimmer.alpha = 0;
        this._dimmer.pivot.set(this._dimmer.width/2, this._dimmer.height/2);
        this._dimmer.position.set(360);
    }

    public show(onContinueCallBack: () => void): void {
        this.visible = true;
        setTimeout(() => {
            this._continueButton.addOnceClickCallback(async () => {
                this._continueButton.enable(false);
                await Promise.resolve(this.close());
                onContinueCallBack();
            });
        }, 500);
    }

    public setCountupEffect(): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._countupEffect.state.setAnimation(0, "large", false)
        });
        return tl;
    }

    protected close(): TimelineLite {
        if (Karen.model.gameData.nextMode === KarenGameMode.NORMAL) {
            KarenSoundManager.playSoundEffect(KarenSoundConfig.MAIN_GAME_MUSIC);
        }
        KarenSoundManager.playSoundEffect(KarenSoundConfig.CAP_WIN_END);
        SlotGame.keypadPlugin.setWin(Karen.model.parsedGameData.totalWin, Karen.model.parsedGameData.showTotalWin, GameHelper.isWinBelowStake());
        KarenSoundManager.fadeAndStopSound({name: KarenSoundConfig.CAP_WIN_LOOP, to: 0, duration: 100});
        return super.close();
    }

    private enableContinueButton(): void {
        this._continueButton.visible = true;
        this._continueButton.enable(true);
    }

    private bounceHit(intencity: number = 0, durr: number = 0.2): TimelineMax {
        this.bounceTl = Helper.setTimelineMax(this.bounceTl, new TimelineMax());
        if (!intencity) return this.bounceTl;

        intencity = Math.min(intencity, 6);
        const inc: number = intencity * 0.05;

        this.bounceTl.to(this._youWin.scale, {duration: durr / 2, x: 1.15 + inc, y: 1.15 + inc}, 0);
        this.bounceTl.to(this._youWin.scale, {duration: durr, x: 1, y: 1, ease: Bounce.easeOut}, durr / 2);

        this.bounceTl.play();

        return this.bounceTl;
    }

    private onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._textSize = 110;
            if (NolimitApplication.screenBounds.width < 970) {
                this._textSize = 90;
            }
        } else {
            this._textSize = 80;
        }

        if (this._youWin.toString().length >= 8) {
            this._textSize = this._textSize - 10;
            if (this._youWin.toString().length >= 10) {
                this._textSize = this._textSize - 10;
            }
        }
        this._youWin.fontSize = this._textSize;
        this._youWin.pivot.set(this._youWin.width / 2, this._youWin.height / 2);
    }
}
